import React from 'react';
import { X, Trash2, AlertTriangle } from 'lucide-react';

const DeleteSubAccountModal = ({ 
  isOpen, 
  onClose, 
  selectedSubAccount, 
  onConfirm, 
  isDeleting,
  getSubAccountDisplayName 
}) => {
  if (!isOpen || !selectedSubAccount) return null;

  const handleConfirm = () => {
    onConfirm(selectedSubAccount._id);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-light-gray">
          <div className="flex items-center">
            <Trash2 className="h-6 w-6 text-error-600 mr-3" />
            <h3 className="text-lg font-medium text-secondary-900">
              Delete Sub Account
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-secondary-400 hover:text-secondary-600 transition-colors"
            disabled={isDeleting}
            style={{ color: '#9ca3af' }}
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Warning Icon */}
          <div className="flex justify-center mb-4">
            <div className="h-16 w-16 bg-error-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="h-8 w-8 text-error-600" />
            </div>
          </div>

          {/* Warning Message */}
          <div className="text-center mb-6">
            <h4 className="text-lg font-medium text-secondary-900 mb-2">
              Are you sure you want to delete this sub-account?
            </h4>
            <p className="text-sm text-secondary-600">
              This action cannot be undone. The sub-account will be permanently removed from the system.
            </p>
          </div>

          {/* Sub Account Details */}
          <div className="bg-secondary-50 rounded-lg p-4 mb-6">
            <div className="flex items-center">
              <div className="flex-shrink-0 h-10 w-10">
                <div className="h-10 w-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-sm font-medium text-primary-600">
                    {getSubAccountDisplayName(selectedSubAccount).charAt(0).toUpperCase()}
                  </span>
                </div>
              </div>
              <div className="ml-3">
                <div className="text-sm font-medium text-secondary-900">
                  {getSubAccountDisplayName(selectedSubAccount)}
                </div>
                <div className="text-sm text-secondary-500">
                  {selectedSubAccount.email}
                </div>
                <div className="text-xs text-secondary-400">
                  {selectedSubAccount.role === 'super_admin' ? 'Super Admin' :
                   selectedSubAccount.role === 'issuer' ? 'Issuer' :
                   selectedSubAccount.role === 'custodian' ? 'Custodian' :
                   selectedSubAccount.role === 'facility_agent' ? 'Facility Agent' :
                   selectedSubAccount.role === 'investor' ? 'Investor' :
                   selectedSubAccount.role === 'arranger' ? 'Arranger' :
                   selectedSubAccount.role === 'exchange' ? 'Exchange' :
                   selectedSubAccount.role}
                </div>
              </div>
            </div>
          </div>

          {/* Warning Box */}
          <div className="bg-error-50 border border-error-200 rounded-md p-4 mb-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <AlertTriangle className="h-5 w-5 text-error-400" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-error-800">
                  Important Warning
                </h3>
                <div className="mt-2 text-sm text-error-700">
                  <p>• All data associated with this sub-account will be permanently deleted</p>
                  <p>• The sub-account will lose access to all system features</p>
                  <p>• This action cannot be reversed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              disabled={isDeleting}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={isDeleting}
              className="btn-primary"
            >
              {isDeleting ? (
                <div className="flex items-center">
                  <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full mr-2"></div>
                  Deleting...
                </div>
              ) : (
                'Delete Sub Account'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteSubAccountModal; 